<router-outlet></router-outlet>


<!-- Botón flotante global -->
<app-floating-chat
  [phone]="'51987654321'"
  [advisorName]="'Luciana López'"
  [advisorRole]="'Asesora Comercial'"
  [presetMessage]="'Hola, me gustaría recibir información sobre sus equipos.'">
</app-floating-chat>